import React, { useEffect } from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Input,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

export default function MultiSelectDD({
  header = "Data Center List",
  className = "",
  optionsList = [],
  selectedIds = [],
  disabled = false,
  minWidth = "200px",
  width = "initial",
  onChange = () => {},
  isRequired = false,
  showSelectAll = true,
  toolTip = "",
  index = 0
}) {
  const [selectedId, setSelectedId] = React.useState(selectedIds);

  useEffect(() => {
    setSelectedId(selectedIds);
  }, [selectedIds]);

  const handleChange=()=>
  {
    //console.log(e);
  }
  //Following line we may need for further implementation i.e making multiple dropdown dynamic
  //const selectedValues = optionsList.filter((f)=> selectedIds.includes(f.id)).map(function(a) {return a.value});
  return (
    <FormControl className={className}>
      {header && header.length > 0 && (
        <InputLabel
          id={"multiple-checkbox-header-label"}
          className={disabled ? "disabled-label" : ""}
        >
          <span>{header}</span>
          {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
          {toolTip && (
            <Tooltip title={toolTip}>
              <IconButton size={"small"} className={"tooltip-iconSize"}>
                <InfoOutlined fontSize={"inherit"} />
              </IconButton>
            </Tooltip>
          )}
        </InputLabel>
      )}
      {/* <DarkTooltip title={showToolTip ? selectedIds.toString() : tooltipTitle}> */}
      <Select
        labelId={"multiple-checkbox-label"}
        id={"multiple-checkbox" + index}
        multiple
        autocomplete={"new-password"}
          autoComplete={"new-password"}
        value={selectedId}
        onChange={(event) => onChange(event.target.value,event.target.checked)}
        onClose={() => {}}
        input={<Input style={{ fontSize: "0.867rem !important" }} />}
        style={{
          maxWidth: "300px",
          minWidth: minWidth,
          width: width,
          fontSize: "0.867rem !important",
        }}
        renderValue={(selected) => {
          return selectedId.indexOf("All") !== -1
            ? selected
                .join(", ")
                .replace(", All", "")
                .replace("All", "")
            : selected.join(", ");
        }}
        disabled={disabled}
      >
        {(optionsList || []).length > 1 && showSelectAll ? (
          <MenuItem key={"masterOption" + 0} value={"All"}>
            <Checkbox checked={selectedId.indexOf("All") !== -1} />
            <ListItemText primary={"Select All"} />
          </MenuItem>
        ) : (
          ""
        )}
          {(optionsList || []).length ==0  ? (
          <MenuItem key={"masterOption" + 0} value={"No Data available"}>
            
            <ListItemText primary={"No Data available"} />
          </MenuItem>
        ) : (
          ""
        )}
        {(optionsList || []).map((data, ic) => (
          <MenuItem key={"masterOption" + (ic + 1)} value={data.id}>
            <Checkbox onChange={(event) => handleChange(event)} checked={selectedId.indexOf(data.id) !== -1} />
            <ListItemText primary={data.value} />
          </MenuItem>
        ))}
      </Select>
      {/* </DarkTooltip> */}
    </FormControl>
  );
}
